import { createFileRoute } from "@tanstack/react-router";
import { BrasilChannelLanding } from "@/components/match/brasil/BrasilChannelLanding";
import { BRASIL_FAQ_BY_CHANNEL, buildFaqJsonLd } from "@/components/growth/BrasilFaq";

export const Route = createFileRoute("/brasil/n-sports")({
  head: () => ({
    meta: [
      { title: "VerseSport Brasil + N Sports — Segunda tela oficial da torcida" },
      { name: "description", content: "Use o VerseSport como segunda tela enquanto assiste à N Sports: previsões, ranking e Audio Sync sem spoilers." },
      { property: "og:title", content: "VerseSport Brasil + N Sports — Segunda tela oficial da torcida" },
      { property: "og:description", content: "Use o VerseSport como segunda tela enquanto assiste à N Sports: previsões, ranking e Audio Sync sem spoilers." },
      { property: "og:url", content: "https://versesport.com/brasil/n-sports" },
      { property: "og:type", content: "website" },
    ],
    links: [{ rel: "canonical", href: "https://versesport.com/brasil/n-sports" }],
    scripts: [{ type: "application/ld+json", children: JSON.stringify(buildFaqJsonLd(BRASIL_FAQ_BY_CHANNEL["n-sports"])) }],
  }),
  component: () => (
    <BrasilChannelLanding channelId="nsports" channelName="N Sports" intro="Previsões, estatísticas e Nation Wars para a torcida que sintoniza a N Sports." />
  ),
});
